import Navbar from './components/Navbar';
import Home from'./pages/Home';
import Footer from './components/Footer';
import Collabs from './pages/Collaborations';
import Error from './pages/Error';
import CreatePost from './pages/CreatePost';
import Library from './pages/Library';
import Poems from './pages/PoemsLibrary';
import Stories from './pages/Stories';
import DetailedPoem from './pages/DetailedPoem';
import Innocuous from './pages/Innocuous';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Posts from './pages/Posts';


 function App() {
   return (
       <Router>
        <div className="app">
          <Navbar/>
          <div className="content">
              <Routes>
                  <Route exact path="/" element={<Home/>}/>
                  <Route exact path="/innocuous" element={<Innocuous/>} />
                  <Route exact path="/auth/create" element={<CreatePost/>} />
                  <Route exact path="/library" element={<Library/>} />
                  <Route path="/poems/:id" element={<DetailedPoem/>} />
                  <Route exact path="/poems" element={<Poems/>} />
                  <Route exact path="/posts" element={<Posts/>} />
                  <Route exact path="/stories" element={<Stories/>} />
                  <Route exact path="/collabs" element={<Collabs/>} />
                  <Route path="*" element={<Error/>} />
              </Routes>
          </div>
          <Footer/>
          </div>
      </Router> 
  );
}

export default App;
